import { generateDenominatorNumerator } from '~/bootcamp/Activities/Fractions/Fractions.utils'

import { getRangesByDifficulty } from './constants'

/**
 * Responsible to generate final term after adjustment and shuffle
 * @param difficultyLevel
 * @param taskHistory
 * @returns { numerator1: number; denominator1: number; numerator2: number; denominator2: number }
 */
export function generateTerms(
  difficultyLevel: number,
  taskHistory: number[],
): { numerator: number; denominator1: number; denominator2: number } {
  const { minNumerator, maxNumerator, minDenominator, maxDenominator } = getRangesByDifficulty(difficultyLevel)

  const { numerator, denominator: denominator1 } = generateDenominatorNumerator(
    minNumerator,
    maxNumerator,
    minDenominator,
    maxDenominator,
    taskHistory,
  )
  const { denominator: denominator2 } = generateDenominatorNumerator(
    minNumerator,
    maxNumerator,
    Math.max(numerator + 1, minDenominator),
    maxDenominator,
    taskHistory,
  )

  if (numerator / denominator1 === numerator / denominator2) {
    return generateTerms(difficultyLevel, taskHistory)
  }

  return { numerator, denominator1, denominator2 }
}
